import { render, staticRenderFns } from "./NuevoEsquemaComisiones.vue?vue&type=template&id=9b6d844c&scoped=true"
import script from "./NuevoEsquemaComisiones.vue?vue&type=script&lang=js"
export * from "./NuevoEsquemaComisiones.vue?vue&type=script&lang=js"
import style0 from "./NuevoEsquemaComisiones.vue?vue&type=style&index=0&id=9b6d844c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9b6d844c",
  null
  
)

export default component.exports